import type { HelpFile } from '../../types/help'
import { AdminNotificationLogTestIds } from '../../../testids/AdminNotificationLogTestIds'

export const adminNotificationLogHelp: HelpFile = {
  docPage: '/docs/my-iam/notifications',
  texts: {
    [AdminNotificationLogTestIds.adminNotificationLog]:
      'System-wide log of every notification sent — recipient, event, delivery status, and any error encountered.',
    [AdminNotificationLogTestIds.colDate]: null,
    [AdminNotificationLogTestIds.colSentAt]:
      'Time the notification was actually delivered — may differ from creation time if delivery was queued.',
    [AdminNotificationLogTestIds.colEventType]:
      'IAM event that triggered this notification — for example access granted or request approved.',
    [AdminNotificationLogTestIds.colTitle]: null,
    [AdminNotificationLogTestIds.colRecipient]: null,
    [AdminNotificationLogTestIds.colDeliveryStatus]:
      'Delivery outcome — sent, pending, or failed.',
    [AdminNotificationLogTestIds.colError]:
      'Error detail captured when delivery failed.',
    [AdminNotificationLogTestIds.notificationStatusSent]:
      'Notification was successfully delivered.',
    [AdminNotificationLogTestIds.notificationStatusPending]:
      'Notification is queued and waiting for delivery.',
    [AdminNotificationLogTestIds.notificationStatusFailed]:
      'Notification delivery failed — see the error column for details.',
  },
}
